/* Artisanal Aqua — small progressive-enhancement helpers.
   Wires arrow buttons on wholesale category carousels. Native swipe/scroll
   already works without JS; the arrows are an enhancement. */
(function () {
  function wireCarousel(root) {
    var track = root.querySelector('.aa-carousel__track');
    if (!track) return;
    var prev = root.querySelector('.aa-carousel__btn--prev');
    var next = root.querySelector('.aa-carousel__btn--next');
    function step() {
      var item = track.querySelector('.aa-carousel__item');
      if (!item) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      return item.getBoundingClientRect().width + gap;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }
  function init() {
    var nodes = document.querySelectorAll('[data-aa-carousel]');
    for (var i = 0; i < nodes.length; i++) wireCarousel(nodes[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Subscription cancellation-policy link. In the cart, the Shopify subscription
   agreement renders the words "cancellation policy" as
   <span id="shopify-subscription-policy-button">. Shopify's payment-terms module
   is supposed to wire it to open the policy, but it doesn't fire inside this
   theme's cart drawer, so the text looks clickable yet does nothing. We wire it
   ourselves: open the store's Subscription policy in a lightweight modal.
   Delegated on document so it works no matter when the drawer renders. */
(function () {
  var POLICY_URL = '/policies/subscription-policy';
  var cachedBody = null;
  var overlay = null;

  function buildOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'aa-policy-overlay';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="aa-policy-modal" role="dialog" aria-modal="true" aria-label="Cancellation policy">' +
      '<button type="button" class="aa-policy-close" aria-label="Close">&times;</button>' +
      '<div class="aa-policy-body" data-aa-policy-body><p>Loading&hellip;</p></div>' +
      '</div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.aa-policy-close')) close();
    });
    return overlay;
  }

  function open() {
    var ov = buildOverlay();
    ov.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    var body = ov.querySelector('[data-aa-policy-body]');
    if (cachedBody) { body.innerHTML = cachedBody; return; }
    fetch(POLICY_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.shopify-policy__body, .rte, main');
        cachedBody =
          '<h2 class="aa-policy-title">Cancellation policy</h2>' +
          (src ? src.innerHTML : '<p>See our <a href="' + POLICY_URL + '">cancellation policy</a>.</p>');
        body.innerHTML = cachedBody;
      })
      .catch(function () {
        // Fallback: if the fetch fails, just send them to the policy page.
        window.open(POLICY_URL, '_blank', 'noopener');
        close();
      });
  }

  function close() {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#shopify-subscription-policy-button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && !overlay.hasAttribute('hidden')) close();
  });
})();
